import { AxiosError, AxiosResponse } from "axios";
import { createApi } from "../../../utils/createApi";
import { fetchAddCameraInfo } from "../../Sites/SitesPage/SitesPageUtils/fetchAddCameraInfo";
import { createStreamsObject } from "./createStreamsObject";
import { matchAllStreams } from "./numericallySortAlerts";
import { IgnoreZonesBreadCrumbs } from "../../EditIgnoreZones/IgnoreZonesBreadCrumbs";
import { getAxisData } from "./getAxisData";
import { getMobotixData } from "./getMobotixData";
import { generateActiveProducts } from "./generateActiveProducts";
import { GeneralInfoEditCameraTab } from "../GeneralInfoEditCameraTab";
import { CameraInfoRow } from "../../Sites/SiteAboutPage/CameraInfoRow";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import {
  isResourceNotFoundError,
  navigateToResourceNotFound,
} from "../../../utils/resourceNotFound";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { checkForAlarmType } from "./checkForAlarmType";
import { getStreamParametersExtraFields } from "./getStreamParametersExtraFields";
import { recordCameraMotionFromGeneralInfo } from "../cameraMotionOverride";
import { useEditCameraStore } from "../editCameraStore/editCameraStore";
import { safeSetItem } from "../../../utils/localStorageUtils";
import { logger } from "../../../../utils/logger";
import { getDefaultAlarmName } from "../../../utils/getDefaultAlarmName";
import { useSiteAboutStore } from "../../Sites/SiteAboutPage/siteAboutStore/siteAboutStore";
import { CameraInfoRowEditCamera } from "../CameraInfoRowEditCamera";
import { buildConnectionsTitlesArray } from "./connectionColumns";

export const getEditCameraData = async (
  navigate: any,
  siteId: any,
  cameraId: any,
  setSiteInfo: any,
  setCameraGeneralInfo: any,
  setCameraObject: any,
  setCameraDataLoaded: any,
  setBackdropLoadingScreenOn: any,
  setImmixAlertsOnCamera: any,
  setIgnoreZonesBreadCrumbs: any,
  createIgnoreZonesLinksArray: any,
  handleSitesBreadcrumbClick: any,
  handleSingularSiteBreadcrumbClick: any,
  setSureViewAlertsOnCamera: any,
  setAxisCamera: any,
  setMobotixFinished: any,
  setRecipientsConfiguredData: any,
  setTitlesArray: any,
  setActionRulesData: any,
  setActionRulesTitlesArray: any,
  setApplicationsConfiguredData: any,
  mobotixFinished: any,
  setAxisFinished: any,
  axisFinished: any,
  setMobotixCamera: any,
  setTimeTablesData: any,
  setIPNotifyData: any,
  setActionHandlerData: any,
  setCameraGeneralInfoBackup: any,
  setImmixAlerts: any,
  setSureviewAlerts: any,
  setActiveProducts: any,
  setActiveTab: any,
  actionRulesTitlesArray: any,
  applicationsConfiguredData: any,
  cameraGeneralInfo: any,
  actionRulesData: any,
  setSrcImages: any,
  permissions: any,
  setCameraInfoRow: any,
  width: any,
  setCameraWebhookData: any,
  setProductsData: any,
  setBackupProductsData: any,
  setSentinelAlertsOnCamera: any,
  setSentinelAlerts: any,
  setBoldAlertsOnCamera: Dispatcher<boolean>,
  setBoldAlerts: Dispatcher<any>,
  setPatriotAlertsOnCamera: Dispatcher<boolean>,
  setPatriotAlerts: Dispatcher<any>,
  setUSMonitoringAlertsOnCamera: Dispatcher<boolean>,
  setUSMonitoringAlerts: Dispatcher<any>,
  setWebhooksAlertsOnCamera: Dispatcher<boolean>,
  setSoftguardAlertsOnCamera: Dispatcher<boolean>,
  setSoftguardAlerts: Dispatcher<any>,
  setEvalinkAlertsOnCamera: Dispatcher<boolean>,
  setStreamParametersData: React.Dispatch<React.SetStateAction<any>>,
  setShowStreamParameters: React.Dispatch<React.SetStateAction<boolean>>,
  setEditCameraAlerts: Dispatcher<any>,
  setDiceAlertsOnCamera: Dispatcher<boolean>,
  setDiceAlerts: Dispatcher<any>,
  holdBackdropAfterCameraLoad?: () => boolean,
  isMountedRef?: React.MutableRefObject<boolean>
) => {
  // Helper function to safely call state setters only if component is mounted
  const safeSetState = <T,>(
    setter: React.Dispatch<React.SetStateAction<T>> | ((value: T) => void),
    value: T
  ) => {
    if (!isMountedRef || isMountedRef.current) {
      setter(value);
    }
  };
  const { getMetadataTagZones } = useSiteAboutStore.getState();
  const {
    setShowHealthMonitoring,
    handleCheckForVCHOnlySite,
    setShowSlicingWarningMessage,
  } = useEditCameraStore.getState();
  localStorage.setItem("siteId", siteId);
  const AxiosUI = createApi(``);
  const retryFunction = () => {
    getEditCameraData(
      navigate,
      siteId,
      cameraId,
      setSiteInfo,
      setCameraGeneralInfo,
      setCameraObject,
      setCameraDataLoaded,
      setBackdropLoadingScreenOn,
      setImmixAlertsOnCamera,
      setIgnoreZonesBreadCrumbs,
      createIgnoreZonesLinksArray,
      handleSitesBreadcrumbClick,
      handleSingularSiteBreadcrumbClick,
      setSureViewAlertsOnCamera,
      setAxisCamera,
      setMobotixFinished,
      setRecipientsConfiguredData,
      setTitlesArray,
      setActionRulesData,
      setActionRulesTitlesArray,
      setApplicationsConfiguredData,
      mobotixFinished,
      setAxisFinished,
      axisFinished,
      setMobotixCamera,
      setTimeTablesData,
      setIPNotifyData,
      setActionHandlerData,
      setCameraGeneralInfoBackup,
      setImmixAlerts,
      setSureviewAlerts,
      setActiveProducts,
      setActiveTab,
      actionRulesTitlesArray,
      applicationsConfiguredData,
      cameraGeneralInfo,
      actionRulesData,
      setSrcImages,
      permissions,
      setCameraInfoRow,
      width,
      setCameraWebhookData,
      setProductsData,
      setBackupProductsData,
      setSentinelAlertsOnCamera,
      setSentinelAlerts,
      setBoldAlertsOnCamera,
      setBoldAlerts,
      setPatriotAlertsOnCamera,
      setPatriotAlerts,
      setUSMonitoringAlertsOnCamera,
      setUSMonitoringAlerts,
      setWebhooksAlertsOnCamera,
      setSoftguardAlertsOnCamera,
      setSoftguardAlerts,
      setEvalinkAlertsOnCamera,
      setStreamParametersData,
      setShowStreamParameters,
      setEditCameraAlerts,
      setDiceAlertsOnCamera,
      setDiceAlerts,
      holdBackdropAfterCameraLoad,
      isMountedRef
    );
  };
  let getSiteInfoFail = false;
  localStorage.setItem("noAutoAddCamerasDialogOpen", "true");

  let generalInfo: any = {};

  const alarmOptions = localStorage.alarmOptions
    ? JSON.parse(localStorage.alarmOptions)
    : [];

  const alarmIds = new Map();
  alarmOptions.forEach((object: any) => {
    alarmIds.set(object.value, object.name);
  });

  let tempSiteInfo = {};

  const { setSysaidAlertsOnCamera, setNotesText } =
    useEditCameraStore.getState();

  await AxiosUI.get(`customer/${siteId}/about/`).then(
    (response: AxiosResponse) => {
      // Check if component is still mounted before updating state
      if (isMountedRef && !isMountedRef.current) return;

      getSiteInfoFail = false;
      fetchAddCameraInfo(siteId, navigate);
      safeSetState(setSiteInfo, response.data);
      const { setSiteInfoEditCamera } = useEditCameraStore.getState();
      setSiteInfoEditCamera(response.data);
      tempSiteInfo = response.data;
      generalInfo = response.data;
      localStorage.setItem("siteInfo", JSON.stringify(response.data));

      if (response.data.integration_type_name.includes("SMTP")) {
        setShowSlicingWarningMessage(true);
      }

      if (response.data.chm) {
        setShowHealthMonitoring(true);
      }
      if (response.data.integration_type_name === "autopatrol") {
        getMetadataTagZones(navigate);
        handleCheckForVCHOnlySite(navigate);
      }
      checkForAlarmType(
        response.data.default_alarm,
        setBoldAlertsOnCamera,
        setPatriotAlertsOnCamera,
        setSureViewAlertsOnCamera,
        setSentinelAlertsOnCamera,
        setImmixAlertsOnCamera,
        setWebhooksAlertsOnCamera,
        setSoftguardAlertsOnCamera,
        setEvalinkAlertsOnCamera,
        setDiceAlertsOnCamera
      );
      getStreamParametersExtraFields(
        cameraId,
        setStreamParametersData,
        setShowStreamParameters,
        navigate
      );
      safeSetState(
        setIgnoreZonesBreadCrumbs,
        <IgnoreZonesBreadCrumbs
          linksArray={createIgnoreZonesLinksArray(response.data.breadcrumbs)}
          handleSitesBreadcrumbClick={handleSitesBreadcrumbClick}
          handleSingularSiteBreadcrumbClick={handleSingularSiteBreadcrumbClick}
          styling="absolute top-[10px] left-[30px]"
        />
      );
      localStorage.setItem("integrationType", response.data.integration_type);
      if (response.data.auto_add) {
        localStorage.setItem("autoAdd", "true");
      } else {
        localStorage.setItem("autoAdd", "false");
      }
    },
    (reason: AxiosError) => {
      getSiteInfoFail = true;
      if (isResourceNotFoundError(reason)) {
        setBackdropLoadingScreenOn(false);
        navigateToResourceNotFound(navigate, "site", siteId);
      } else {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          alert("Error retrieving site data");
          navigate("/dashboard");
          logger.log(`${reason}`);
          localStorage.setItem("autoAdd", "true");
        });
      }
    }
  );
  !getSiteInfoFail &&
    (await AxiosUI.get(`/camera/${cameraId}/general_info/`).then(
      (response: any) => {
        // Check if component is still mounted before updating state
        if (isMountedRef && !isMountedRef.current) return;

        const cameraObject = response.data;
        setNotesText(cameraObject.notes);
        localStorage.setItem("currentCamera", response.data.camera_name);
        safeSetState(setCameraGeneralInfo, cameraObject);
        // Per-camera motion (ENG-2242): the motion card and the Axis/Mobotix
        // motion-off logic read the camera's override/resolved value from here.
        recordCameraMotionFromGeneralInfo(cameraObject);
        const {
          setCameraStreamsObject,
          setCameraStreamsPatchObject,
          setLineCrossingActive,
          getLineCrossingsData,
          fetchCameraVlmConfig,
        } = useEditCameraStore.getState();

        if (
          cameraObject.camera_view === "fisheye" ||
          cameraObject.camera_view === "180_fisheye"
        ) {
          setShowSlicingWarningMessage(true);
        }

        // Extract lineCrossingActive state from general_info response
        const streams = cameraObject.streams || [];
        let intruderLineCrossingActive = false;
        let vehicleLineCrossingActive = false;

        streams.forEach((stream: any) => {
          const streamMetrics = stream.stream_metrics || [];
          streamMetrics.forEach((metric: any) => {
            if (
              metric.label_name === "intruder_line_crossing" &&
              metric.active
            ) {
              intruderLineCrossingActive = true;
            }
            if (
              metric.label_name === "vehicle_line_crossing" &&
              metric.active
            ) {
              vehicleLineCrossingActive = true;
            }
          });
        });

        setLineCrossingActive({
          intruder: intruderLineCrossingActive,
          vehicle: vehicleLineCrossingActive,
        });

        // Fetch line crossings and VLM config during initial page load
        getLineCrossingsData(navigate, cameraId);
        fetchCameraVlmConfig(Number(cameraId), navigate);
        setCameraStreamsObject(cameraObject.streams);
        setCameraStreamsPatchObject(cameraObject.streams);

        // Store only essential camera info to avoid localStorage quota issues
        const essentialCameraInfo = {
          id: cameraObject.id,
          camera_name: cameraObject.camera_name,
          camera_type: cameraObject.camera_type?.display_name || null,
        };
        safeSetItem("currentCameraInfo", essentialCameraInfo);

        safeSetState(setCameraObject, cameraObject);
        const resolvedDefaultAlarmName = getDefaultAlarmName(
          cameraObject.default_alarm
        );
        if (resolvedDefaultAlarmName === "Immix") {
          safeSetState(setImmixAlertsOnCamera, true);
        }
        if (resolvedDefaultAlarmName === "Dice") {
          safeSetState(setDiceAlertsOnCamera, true);
        }
        if (resolvedDefaultAlarmName === "SureView") {
          safeSetState(setSureViewAlertsOnCamera, true);
        }
        if (resolvedDefaultAlarmName === "Sentinel") {
          safeSetState(setSentinelAlertsOnCamera, true);
        }
        if (resolvedDefaultAlarmName === "Evalink") {
          safeSetState(setEvalinkAlertsOnCamera, true);
        }
        if (resolvedDefaultAlarmName === "Sysaid") {
          setSysaidAlertsOnCamera(true);
        }
        if (cameraObject.streams[0]) {
          cameraObject.streams.forEach((obj: any) => {
            if (obj.bold_alerts[0]) {
              safeSetState(setBoldAlertsOnCamera, true);
            }
            if (obj.patriot_alerts[0]) {
              safeSetState(setPatriotAlertsOnCamera, true);
            }
            if (obj.sysaid_alerts[0]) {
              setSysaidAlertsOnCamera(true);
            }
            if (obj.evalink_alerts?.[0]) {
              safeSetState(setEvalinkAlertsOnCamera, true);
            }
            // if (obj.us_monitoring_alerts[0]) {
            //   safeSetState(setUSMonitoringAlertsOnCamera, true);
            // }
            if (obj.sureview_alerts[0]) {
              safeSetState(setSureViewAlertsOnCamera, true);
            }
            if (obj.immix_alerts[0]) {
              safeSetState(setImmixAlertsOnCamera, true);
              //make a clone object of response
              if (obj.immix_alerts.length > 1) {
                const newSortedObect = cameraObject;
                //make a clone streams of clone object and run numericallySortAlerts on the clone stream object
                const newSortedStreams = matchAllStreams(
                  newSortedObect.streams,
                  "immix_alerts"
                );
                //reassign clone object's streams property to the clone streams
                newSortedObect.streams = newSortedStreams;
                //store the clone object in local storage
                safeSetState(setCameraGeneralInfo, newSortedObect);
              }
            }
            if (obj.dice_alerts?.[0]) {
              safeSetState(setDiceAlertsOnCamera, true);
              //make a clone object of response
              if (obj.dice_alerts.length > 1) {
                const newSortedObect = cameraObject;
                //make a clone streams of clone object and run numericallySortAlerts on the clone stream object
                const newSortedStreams = matchAllStreams(
                  newSortedObect.streams,
                  "dice_alerts"
                );
                //reassign clone object's streams property to the clone streams
                newSortedObect.streams = newSortedStreams;
                //store the clone object in local storage
                safeSetState(setCameraGeneralInfo, newSortedObect);
              }
            }
            if (obj.sureview_alerts[0]) {
              //make a clone object of response
              if (obj.sureview_alerts.length > 1) {
                const newSortedObect = cameraObject;
                //make a clone streams of clone object and run numericallySortAlerts on the clone stream object
                const newSortedStreams = matchAllStreams(
                  newSortedObect.streams,
                  "sureview_alerts"
                );
                //reassign clone object's streams property to the clone streams
                newSortedObect.streams = newSortedStreams;
                //store the clone object in local storage
                safeSetState(setCameraGeneralInfo, newSortedObect);
              }
            }
          });
        }
        if (cameraObject.camera_type) {
          if (cameraObject.camera_type.display_name === "Axis") {
            safeSetState(setAxisCamera, true);
            safeSetState(setMobotixFinished, {
              timeTable: true,
              iPNotify: true,
              actionHandler: true,
            });
            getAxisData(
              cameraObject.id,
              navigate,
              setRecipientsConfiguredData,
              setTitlesArray,
              setActionRulesData,
              setActionRulesTitlesArray,
              setApplicationsConfiguredData,
              mobotixFinished,
              setAxisFinished,
              setBackdropLoadingScreenOn,
              axisFinished,
              setActiveTab,
              actionRulesTitlesArray,
              applicationsConfiguredData,
              cameraGeneralInfo,
              actionRulesData
            );
          } else if (cameraObject.camera_type.display_name === "Mobotix") {
            safeSetState(setMobotixCamera, true);
            safeSetState(setAxisFinished, {
              recipient: true,
              actionRules: true,
              application: true,
            });
            getMobotixData(
              cameraObject.id,
              navigate,
              setTimeTablesData,
              setBackdropLoadingScreenOn,
              setIPNotifyData,
              setActionHandlerData,
              axisFinished,
              mobotixFinished,
              setMobotixFinished
            );
          }
        }
        // Titles and cells are matched by position; both come from
        // connectionColumns.ts so they cannot drift apart.
        const connectionsTitlesArray = buildConnectionsTitlesArray(
          cameraObject,
          tempSiteInfo
        );
        localStorage.setItem(
          "connectionsTitlesArray",
          JSON.stringify(connectionsTitlesArray)
        );
        safeSetState(setCameraGeneralInfoBackup, cameraObject);
        const pushedArrayImmix: any[] = [];
        const pushedArrayDice: any[] = [];
        const pushedArraySentinel: any[] = [];
        if (cameraObject.streams[0]) {
          if (cameraObject.streams[0].immix_alerts[0]) {
            cameraObject.streams[0].immix_alerts.forEach((object: any) => {
              pushedArrayImmix.push(object);
            });
          }
          if (cameraObject.streams[0].dice_alerts?.[0]) {
            cameraObject.streams[0].dice_alerts.forEach((object: any) => {
              pushedArrayDice.push(object);
            });
          }
          if (cameraObject.streams[0].sentinel_alerts[0]) {
            cameraObject.streams[0].sentinel_alerts.forEach((object: any) => {
              pushedArraySentinel.push(object);
            });
          }
        }
        safeSetState(setImmixAlerts, pushedArrayImmix);
        safeSetState(setDiceAlerts, pushedArrayDice);
        safeSetState(setSentinelAlerts, pushedArraySentinel);
        if (cameraObject.streams[0]) {
          cameraObject.streams.forEach((streamObject: any) => {
            if (streamObject.sureview_alerts[0]) {
              localStorage.setItem(
                "sureViewStreamObject",
                JSON.stringify(streamObject)
              );
            } else if (streamObject.immix_alerts[0]) {
              localStorage.setItem(
                "immixStreamObject",
                JSON.stringify(streamObject)
              );
            } else if (streamObject.dice_alerts?.[0]) {
              localStorage.setItem(
                "diceStreamObject",
                JSON.stringify(streamObject)
              );
            }
          });
        }

        const sureViewPushedArray: any[] = [];
        if (cameraObject.streams[0]) {
          if (cameraObject.streams[0].sureview_alerts[0]) {
            cameraObject.streams[0].sureview_alerts.forEach((object: any) => {
              sureViewPushedArray.push(object);
            });
          }
        }
        safeSetState(setSureviewAlerts, sureViewPushedArray);

        const boldPushedArray: any[] = [];
        if (cameraObject.streams[0]) {
          if (cameraObject.streams[0].bold_alerts[0]) {
            cameraObject.streams[0].bold_alerts.forEach((object: any) => {
              boldPushedArray.push(object);
            });
          }
        }

        safeSetState(setBoldAlerts, boldPushedArray);

        const patriotPushedArray: any[] = [];
        if (cameraObject.streams[0]) {
          if (cameraObject.streams[0].patriot_alerts[0]) {
            cameraObject.streams[0].patriot_alerts.forEach((object: any) => {
              patriotPushedArray.push(object);
            });
          }
        }

        safeSetState(setPatriotAlerts, patriotPushedArray);

        const softguardPushedArray: any[] = [];
        if (cameraObject.streams[0]) {
          if (cameraObject.streams[0].softguard_alerts[0]) {
            cameraObject.streams[0].softguard_alerts.forEach((object: any) => {
              softguardPushedArray.push(object);
            });
          }
        }

        safeSetState(setSoftguardAlerts, softguardPushedArray);

        // const usMonitoringPushedArray: any[] = [];
        // if (cameraObject.streams[0]) {
        //   if (cameraObject.streams[0].us_monitoring_alerts[0]) {
        //     cameraObject.streams[0].us_monitoring_alerts.forEach((object: any) => {
        //       usMonitoringPushedArray.push(object);
        //     });
        //   }
        // }

        // setUSMonitoringAlerts(usMonitoringPushedArray);

        const streamsObject = createStreamsObject(cameraObject.streams);

        generateActiveProducts(
          streamsObject,
          setActiveProducts,
          setProductsData,
          setBackupProductsData
        );

        safeSetState(
          setActiveTab,
          <GeneralInfoEditCameraTab
            siteInfo={generalInfo}
            cameraGeneralInfo={cameraObject}
          />
        );
        AxiosUI.get(`/camera/${cameraObject.id}/status/`).then(
          (response: AxiosResponse) => {
            // Check if component is still mounted before updating state
            if (isMountedRef && !isMountedRef.current) return;

            const name = `${cameraObject.id}full`;
            safeSetState(setSrcImages, (previousState: any) => {
              return {
                ...previousState,
                [cameraObject.id]: (
                  <img src={response.data.preview_url} alt="site_image" />
                ),
                [name]: response.data,
              };
            });
            safeSetState(
              setCameraInfoRow,
              <CameraInfoRowEditCamera
                obj={cameraObject}
                expanded={true}
                setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                setEditCameraAlerts={setEditCameraAlerts}
                siteInfo={tempSiteInfo}
                permissions={permissions}
                srcImages={{
                  [cameraObject.id]: (
                    <img src={response.data.preview_url} alt="site_image" />
                  ),
                  [name]: response.data,
                }}
              />
            );
            const { getWebhooksData, getCameraStreams } =
              useEditCameraStore.getState();
            getCameraStreams(navigate, cameraObject.id);
            getWebhooksData(navigate, cameraObject.id);
          },
          (reason: AxiosError) => {
            universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
          }
        );
        safeSetState(setCameraDataLoaded, true);
        if (!holdBackdropAfterCameraLoad?.()) {
          safeSetState(setBackdropLoadingScreenOn, false);
        }
      },
      (reason: AxiosError) => {
        if (isResourceNotFoundError(reason)) {
          setBackdropLoadingScreenOn(false);
          navigateToResourceNotFound(navigate, "camera", cameraId);
        } else {
          universalAPIErrorHandler(reason, navigate, retryFunction, () => {
            alert("Error retrieving site data");
            navigate("/");
          });
        }
      }
    ));
};
